import { useLocation } from 'react-router';

export function humanFileSize(bytes, si = true, dp = 1) {
    const thresh = si ? 1000 : 1024;

    if (Math.abs(bytes) < thresh) {
        return bytes + ' B';
    }

    const units = si
        ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
        : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
    let u = -1;
    const r = 10 ** dp;

    do {
        bytes /= thresh;
        ++u;
    } while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1);

    return bytes.toFixed(dp) + ' ' + units[u];
}

export function getSafe(fn, fallbackValue) {
    try { return fn(); }
    catch (e) { return fallbackValue; }
}

export function moveItemInArray(array, from, to) {
    array.splice(to, 0, array.splice(from, 1)[0]);
}

export function useQuery() {
    return new URLSearchParams(useLocation().search);
}  

export function capitalize(str = "") {
    return str.charAt(0).toUpperCase() + str.slice(1)
}
